
import {Component, Mixins, Ref, Watch} from "vue-property-decorator";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import GenelIslemFormWizard, {GenelIslemEntity} from "@/components/forms/form-wizard/eicrapro/GenelIslemFormWizard.vue";
import {VForm} from "@/types";
import PersonelPicker from "@/components/pickers/PersonelPicker.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import HacizTalepHazirlaForm from "@/components/forms/HacizTalepHazirlaForm.vue";
import {ITask, Task} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {TaskTuru} from "@/plugins/uyap-plugin/enum/TaskTuru";
import {TaskDurum} from "@/plugins/uyap-plugin/enum/TaskDurum";
import UyapHacizTalepListForm from "@/components/forms/form-wizard/eicrapro/UyapHacizTalepListForm.vue";
import AvukatTalepPicker from "@/components/pickers/uyap/AvukatTalepPicker.vue";
import MahrumiyetInfo from "@/components/infos/eicrapro/MahrumiyetInfo.vue";
import BankaHacziTalepEvrakForm from "@/components/forms/uyap-evrak/haciz-evrak/BankaHacziTalepEvrakForm.vue";
import MaasHacziTalepEvrakForm from "@/components/forms/uyap-evrak/haciz-evrak/MaasHacziTalepEvrakForm.vue";
import SgkMossipHacziTalepEvrakForm from "@/components/forms/uyap-evrak/haciz-evrak/SgkMossipHacziTalepEvrakForm.vue";
import {UyapHacizEvrakTuru} from "@/plugins/uyap-plugin/enum/uyap/evrak/UyapHacizEvrakTuru";
import {AvukatTalepListCevapRow} from "@/plugins/uyap-plugin/uyap/AvukatTalepList";
import TasinirHacizTalepEvrakForm from "@/components/forms/uyap-evrak/haciz-evrak/TasinirHacizTalepEvrakForm.vue";
import TasinirHacizTalimatiTalepEvrakForm
  from "@/components/forms/uyap-evrak/haciz-evrak/TasinirHacizTalimatiTalepEvrakForm.vue";
import IhbarnameTalepEvrakForm from "@/components/forms/uyap-evrak/haciz-evrak/IhbarnameTalepEvrakForm.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import {MDB} from "@/plugins/uyap-plugin/MDB";
import {
  TopluHacizHazirlaTaskHandler
} from "@/plugins/uyap-plugin/store/modules/TaskHandler/TopluHacizHazirlaTaskHandler";
import {ProgramPaths} from "@/enum/ProgramPaths";
import NewFormWrapper from "@/components/NewFormWrapper.vue";
import NewFormDialog from "@/components/dialogs/NewFormDialog.vue";
import TopluHacizTalepDuzenleForm from "@/components/eicrapro/TopluHacizTalepDuzenleForm.vue";

@Component({
  computed: {
    MDB() {
      return MDB
    }
  },
  components: {
    TopluHacizTalepDuzenleForm,
    NewFormDialog,
    NewFormWrapper,
    FormWrapper,
    IhbarnameTalepEvrakForm,
    TasinirHacizTalimatiTalepEvrakForm,
    TasinirHacizTalepEvrakForm,
    SgkMossipHacziTalepEvrakForm,
    MaasHacziTalepEvrakForm,
    BankaHacziTalepEvrakForm,
    MahrumiyetInfo,
    AvukatTalepPicker,
    UyapHacizTalepListForm, HacizTalepHazirlaForm, FormDialog, PersonelPicker, GenelIslemFormWizard
  }
})

export default class TopluHacizHazirlaFormWizard extends Mixins(SimpleInputMixin) {
  @Ref('form') readonly form!: VForm;
  @Ref('genelIslemForm') genelIslemForm!: GenelIslemFormWizard;

  // TODO: genel işleme task için ayrı class ekle
  localValue: GenelIslemEntity = new GenelIslemEntity();
  taskDurum = TaskDurum;
  topluHacizDurum = TopluHacizDurum;
  durum: TopluHacizDurum = this.topluHacizDurum.bosta;
  hacizEvrakTuru = UyapHacizEvrakTuru;
  valid = false;
  onFly = false;
  hideNext = false;
  talepler: Array<AvukatTalepListCevapRow> = [];
  message = "";
  ucretliSorguyaDevamEt = false;

  uyapConcurrentDialogOpen = false;
  uyapConcurrentDialogCountdown = 0;
  uyapConcurrentRememberSkip = false;
  concurrentPromptContext: { errorMessage: string; resolve: (action: 'retry' | 'skip') => void } | null = null;
  concurrentCountdownTimer: number | null = null;

  stepperHeaders = [
    "Listelenecek Takipler",
    "Takipleri Seç",
    "Haciz Evraklarını Hazırla",
    "Haciz Evraklarını Gönder",
    "İşlemler Sıraya Alındı"
  ];
  secilenHeaders = [
    {text: "Birim Adı", value: "birimAdi"},
    {text: "Dosya Esas No", value: "dosyaNo"},
    {text: "Açılış Tarihi", value: "dosyaAcilisTarihi"},
    {text: "Dosya Durumu", value: "dosyaDurum"}
    /* {text: "Durum", value: "status", align: 'center'}*/
  ];

  talepDuzenleHeaders = [
    {text: "", value: "select", sortable: false, width: "50"},
    {text: "Dosya", value: "dosya", width: "400"},
    {text: "Borçlu", value: "borclu"},
    {text: "Durum", value: "durum", sortable: false},
    {text: "İşlemler", value: "actions", sortable: false}
  ];

  varsayilanTalepler = {
    bankaHaczi: {
      muafBankaList: [],
      hesapList: [],
      evrakAdi: "",
      evrakAdiSTR: "",
      haricAdi: "",
      haricAdiSTR: "",
      tebligTarihi: "",
    },
    maasHaczi: {
      kurumId: 0,
      kurumAdi: "",
      calismaDurumu: null,
      calismaDurumuText: "",
      maasininBirBoluDordu: false,
      alacaklarininTamami: false,
      emekliIkramiyeHaczi: "",
      nafaka: false,
      nafakaTutari: "",
      aciklama: ""
    },
    tasinirHaczi: {
      aciklama: ""
    },
    tasinirHacizTalimati: {
      birimId: "",
      birimAdi: "",
      aciklama: ""
    },
    ihbarname89_1: {
      kisiler: [] as Array<any>,
      tebligatTuru: "",
      tebligatTuruAciklama: "",
      adresTuru: "",
      adresTuruAciklama: "",
      adres: ""
    },
    ihbarname89_2: {
      tebligTarihi: "",
      tebligatTuru: "",
      tebligatTuruAciklama: "",
      adresTuru: "",
      adresTuruAciklama: "",
      adres: ""
    },
    ihbarname89_3: {
      tebligTarihi: "",
      tebligatTuru: "",
      tebligatTuruAciklama: "",
      adresTuru: "",
      adresTuruAciklama: "",
      adres: ""
    }
  }

  async mounted() {
    let hesapList:any = (await this.$uyap.BankaHacziParams().run({})).hesaplar.sort((a, b) => (a.aciklama.localeCompare(b.aciklama)));
    this.varsayilanTalepler.bankaHaczi={
      muafBankaList: [],
      hesapList: hesapList,
      evrakAdi: "MZK",
      evrakAdiSTR: "Haciz Müzekkeresi",
      haricAdi: "MAAS",
      haricAdiSTR: "Maaş Hesabı Hariç",
      tebligTarihi: "",
    }
  }

  async setVarsayilanTalep(hacizEvrakTuru: UyapHacizEvrakTuru) {
    for (let takip of this.localValue.secilen_takipler) {
      for (let borclu of takip.task.response.borclular) {
        switch (hacizEvrakTuru) {
          case UyapHacizEvrakTuru.banka_haczi:
            await this.setVarsayilanBankaHaczi(borclu);
            break;
          // case UyapHacizEvrakTuru.maas_haczi:
          //   await this.setVarsayilanMaasHaczi(borclu);
          //   break;
          case UyapHacizEvrakTuru.tasinir_haciz:
            this.setVarsayilanTasinirHaczi(borclu);
            break;
          case UyapHacizEvrakTuru.tasinir_haciz_talimati:
            this.setVarsayilanTasinirHacizTalimati(borclu);
            break;
          case UyapHacizEvrakTuru.ihbarname89_1:
            await this.setVarsayilanIhbarname89_1(borclu, takip);
            break;
          // case UyapHacizEvrakTuru.ihbarname89_2:
          //   await this.setVarsayilanIhbarname89_2(borclu);
          //   break;
          // case UyapHacizEvrakTuru.ihbarname89_3:
          //   await this.setVarsayilanIhbarname89_3(borclu);
          //   break;
        }
      }
    }
  }

  async setVarsayilanBankaHaczi(borclu: any) {
    let varsayilanBankaHaczi = this.varsayilanTalepler.bankaHaczi;
    let bankalar:any = (await this.$uyap.BankaHacziParams().run({})).bankalar.sort((a, b) => (a.ilgili.localeCompare(b.ilgili)));
    bankalar.forEach((banka:any) => {
      banka.kisaAd = banka.ilgili
          .replace("TÜRK ANONİM ŞİRKETİ", "T.A.Ş.")
          .replace("ANONİM ŞİRKETİ", "A.Ş.")
          .replace("TÜRK ANONİM ORTAKLIĞI", "T.A.O.")
          .replace("TÜRKİYE CUMHURİYETİ", "T.C.")
          .replace(" GENEL MÜDÜRLÜĞÜ", "")
          .toLocaleLowerCase('tr')
    });
    let mevcutBorcluBankalar = (borclu.bankaBilgileri?.sorguSonucDVO || []).map((banka: any) => banka.bankaAdi.toLocaleLowerCase('tr'));
    let secilecekBorcluBankalar = bankalar.filter((banka:any) => mevcutBorcluBankalar.includes(banka.kisaAd) && !varsayilanBankaHaczi.muafBankaList.includes(banka.ilgiliKisiIlkKisiKurumId));
    borclu.haciz.bankaHesapHacziParams = {
      bankaList: secilecekBorcluBankalar,
      hesapList: varsayilanBankaHaczi.hesapList,
      evrakAdi: varsayilanBankaHaczi.evrakAdi,
      evrakAdiSTR: varsayilanBankaHaczi.evrakAdiSTR,
      haricAdi: varsayilanBankaHaczi.haricAdi,
      haricAdiSTR: varsayilanBankaHaczi.haricAdiSTR,
      tebligTarihi: varsayilanBankaHaczi.tebligTarihi
    }
  }

  // TODO: buranın kurgusu görüşülecek wip
  // async setVarsayilanMaasHaczi(borclu: any){
  //   let varsayilanMaasHaczi = this.varsayilanTalepler.maasHaczi;
  //   if (varsayilanMaasHaczi.calismaDurumu == 0 || varsayilanMaasHaczi.calismaDurumu == 1) {
  //     // todo: kota kullanımını azaltacak bir fonksiyon yaz
  //   }
  // }

  setVarsayilanTasinirHaczi(borclu: any){
    borclu.haciz.tasinirHacizParams = this.varsayilanTalepler.tasinirHaczi.aciklama;
  }

  setVarsayilanTasinirHacizTalimati(borclu: any){
    let varsayilanTasinirHacizTalimati = this.varsayilanTalepler.tasinirHacizTalimati;
    borclu.haciz.tasinirHacizTalimatiParams = {
      aciklama: varsayilanTasinirHacizTalimati.aciklama,
      birimAdi: varsayilanTasinirHacizTalimati.birimAdi,
      birimId: varsayilanTasinirHacizTalimati.birimId
    }
  }

  async setVarsayilanIhbarname89_1(borclu: any, takip: any){
    let varsayilanIhbarname89_1 = this.varsayilanTalepler.ihbarname89_1;
    if (!varsayilanIhbarname89_1.kisiler || varsayilanIhbarname89_1.kisiler.length === 0) return;

    let dosyaId = takip.dosyaId;
    if (!dosyaId) return;
    let kisi = varsayilanIhbarname89_1.kisiler.find((k: any) => k.dosyalar && k.dosyalar.includes(dosyaId));
    if (!kisi) return;

    let tarafList = await this.$uyap.GetDosyaTarafListesiWithTarafRol().run({
      dosyaId: dosyaId,
      islemTuru: 26
    });

    let mevcutTaraf = tarafList.find((t: any) =>
        t.kisiKurumBilgileriDVO?.kisiKurumId === kisi.temelBilgileri?.kisiKurumID ||
        t.guncelKisiKurumId === kisi.temelBilgileri?.kisiKurumID
    );

    if (!mevcutTaraf) {
      try {
        let uyapIslemTur = 5;
        await this.$uyap.DosyaTarafKaydet().run({
          dosyaId: dosyaId,
          uyapIslemTur: uyapIslemTur,
          TarafList: JSON.stringify([kisi])
        });
        tarafList = await this.$uyap.GetDosyaTarafListesiWithTarafRol().run({
          dosyaId: dosyaId,
          islemTuru: 26
        });
        mevcutTaraf = tarafList.find((t: any) =>
            t.kisiKurumBilgileriDVO?.kisiKurumId === kisi.temelBilgileri?.kisiKurumID ||
            t.guncelKisiKurumId === kisi.temelBilgileri?.kisiKurumID
        );
      } catch (e) {
        console.error("DosyaTarafKaydet hatası:", e);
        this.$toast.error("Üçüncü taraf dosyaya eklenirken hata oluştu.");
        return;
      }
    }

    if (mevcutTaraf) {
      borclu.haciz.ihbarname89_1Params = {
        kisiKurumId: mevcutTaraf.guncelKisiKurumId,
        tebligatTuru: varsayilanIhbarname89_1.tebligatTuru,
        tebligatTuruAciklama: varsayilanIhbarname89_1.tebligatTuruAciklama,
        adresTuru: varsayilanIhbarname89_1.adresTuru,
        adresTuruAciklama: varsayilanIhbarname89_1.adresTuruAciklama,
        adres: varsayilanIhbarname89_1.adres,
        tarafList: ""
      };
    }
  }
  //
  // async setVarsayilanIhbarname89_2(borclu: any){
  //   let varsayilanIhbarname89_2 = this.varsayilanTalepler.ihbarname89_2;
  //
  // }
  //
  // async setVarsayilanIhbarname89_3(borclu: any){
  //   let varsayilanIhbarname89_3 = this.varsayilanTalepler.ihbarname89_3;
  //
  // }

  get showTalepAyar(): boolean {
    let talepAyarItems = [
      this.hacizEvrakTuru.banka_haczi,
      // this.hacizEvrakTuru.maas_haczi,
      this.hacizEvrakTuru.tasinir_haciz,
      this.hacizEvrakTuru.tasinir_haciz_talimati,
      this.hacizEvrakTuru.ihbarname89_1,
      // this.hacizEvrakTuru.ihbarname89_2,
      // this.hacizEvrakTuru.ihbarname89_3
    ];
    let show=false;
    for (const talep of this.talepler) {
      if (talepAyarItems.includes(talep.talepKodu)) {
        show = true;
        break;
      }
    }
    return show;
  }

  @Watch('localValue.secilen_takipler')
  async onSecilenTakiplerChange() {
    console.log("onSecilenTakiplerChange");
    let secilenTakip: any;
    for (secilenTakip of this.localValue.secilen_takipler) {
      if (!secilenTakip.task) {
        secilenTakip.task = new Task();
        secilenTakip.task.dosya_esas_no = secilenTakip.dosyaNo;
        secilenTakip.task.birim_adi = secilenTakip.birimAdi;
        secilenTakip.task.task_type_id = TaskTuru.toplu_haciz_hazirla;
        //For excel loading
        if(typeof secilenTakip.birimId != "undefined"){
          try{
            secilenTakip.task.birimId = secilenTakip.birimId;
            secilenTakip.task.dosyaAcilisTarihi = new Date(this.$uyapHelper.formatDate(secilenTakip.dosyaAcilisTarihi)).toString();
            secilenTakip.task.dosya_id = secilenTakip.dosyaId;
          }catch (e) {
              console.log("secilen takip hata aldi birimId den ",secilenTakip);
              console.log(e);
          }
        }
        this.input();
      }
    }
    console.log("changed localValue.secilen_takipler",this.localValue.secilen_takipler)
  }

  onStepChange(stepNo: number) {
    if (stepNo == 3)
      this.hideNext = true;
    else
      this.hideNext = false;
  }

  clearConcurrentCountdown() {
    if (this.concurrentCountdownTimer !== null) {
      clearInterval(this.concurrentCountdownTimer);
      this.concurrentCountdownTimer = null;
    }
  }

  showConcurrentDialog(errorMessage: string): Promise<'retry' | 'skip'> {
    return new Promise((resolve) => {
      this.concurrentPromptContext = { errorMessage, resolve };
      this.uyapConcurrentDialogOpen = true;
      this.uyapConcurrentDialogCountdown = 10;
      this.concurrentCountdownTimer = window.setInterval(() => {
        this.uyapConcurrentDialogCountdown--;
        if (this.uyapConcurrentDialogCountdown <= 0) {
          this.clearConcurrentCountdown();
          this.uyapConcurrentDialogOpen = false;
          this.concurrentPromptContext!.resolve('retry');
          this.concurrentPromptContext = null;
        }
      }, 1000);
    });
  }

  onConcurrentDialogAtla() {
    this.clearConcurrentCountdown();
    this.uyapConcurrentDialogOpen = false;
    if (this.concurrentPromptContext) {
      this.concurrentPromptContext.resolve('skip');
      this.concurrentPromptContext = null;
    }
  }

  onConcurrentDialogTekrarDene() {
    this.clearConcurrentCountdown();
    this.uyapConcurrentDialogOpen = false;
    if (this.concurrentPromptContext) {
      this.concurrentPromptContext.resolve('retry');
      this.concurrentPromptContext = null;
    }
  }

  onTalepChange() {
    this.localValue.secilen_takipler.forEach(takip => {
      if (takip.task && (takip.task.status == this.taskDurum.BITTI_BASARILI || takip.task.status == this.taskDurum.BITTI_HATALI))
        takip.task.status = this.taskDurum.SIRADA;
    })
    this.input();
  }

  async createHacizHazirlaTask() {
    if (this.form.validate()) {
      this.onFly = true;
      this.durum = this.topluHacizDurum.hazirlaniyor;
      this.message = "Talepler hazırlanıyor...";
      console.log("this.localValue.secilen_takipler",this.localValue.secilen_takipler);
      console.log("Object.entries(this.localValue.secilen_takipler)",Object.entries(this.localValue.secilen_takipler));
      for (let [index, takip] of Object.entries(this.localValue.secilen_takipler)) {
        if(typeof takip.task == "undefined"){
          console.log("TAKIBIN TASKI BULUNAMADI ---- ",takip);
          this.$toast.error("takip bulunamadi atlandi !");
          continue;
        }
        // @ts-ignore
        let task: ITask = takip.task;
        console.log("WORK TASK",task);
        if (typeof task.status == "undefined") {
          task.status = TaskDurum.SIRADA;
        }
        try {
          this.message = (Number(index) + 1) + ". dosyanın talepleri hazırlanıyor.";
          if (task.status == TaskDurum.SIRADA) {
            task.data = {
              hacizParams: this.talepler,
              ucretliSorguyaDevamEt: this.ucretliSorguyaDevamEt
            };
            let handler = new TopluHacizHazirlaTaskHandler();
            let shouldSkip = false;
            let yenidenDene = true;
            while (yenidenDene) {
              try {
                let taskResult = await handler.handle(task);
                task = taskResult;
                task.status = this.taskDurum.BITTI_BASARILI;
                yenidenDene = false;
              } catch (er: any) {
                if (er?.errorCode === 'PRTL_GNL_10001-61') {
                  const action = this.uyapConcurrentRememberSkip
                    ? 'skip'
                    : await this.showConcurrentDialog(er.message);
                  if (action === 'skip') {
                    task.status = this.taskDurum.BITTI_HATALI;
                    task.description  = er.message;
                    yenidenDene = false;
                    shouldSkip = true;
                  }
                } else {
                  task.status = this.taskDurum.BITTI_HATALI;
                  task.description  = er.message;
                  console.log("TopluHacizHazirlaTaskHandler error", er);
                  yenidenDene = false;
                  shouldSkip = true;
                }
              }
            }
            if (shouldSkip) continue;
          }
          this.message = Number(index + 1) + ". dosyanın varsayılan talepleri uygulanıyor."
          for (let borclu of task.response.borclular) {
            borclu.selected = true;
            if (this.talepler.some(talep => talep.talepKodu == this.hacizEvrakTuru.banka_haczi))
              await this.setVarsayilanBankaHaczi(borclu);
            // if (this.talepler.some(talep => talep.talepKodu == this.hacizEvrakTuru.maas_haczi))
            //   await this.setVarsayilanMaasHaczi(borclu);
            if (this.talepler.some(talep => talep.talepKodu == this.hacizEvrakTuru.tasinir_haciz))
              this.setVarsayilanTasinirHaczi(borclu);
            if (this.talepler.some(talep => talep.talepKodu == this.hacizEvrakTuru.tasinir_haciz_talimati))
              this.setVarsayilanTasinirHacizTalimati(borclu);
            if (this.talepler.some(talep => talep.talepKodu == this.hacizEvrakTuru.ihbarname89_1))
              await this.setVarsayilanIhbarname89_1(borclu, takip);
            // if (this.talepler.some(talep => talep.talepKodu == this.hacizEvrakTuru.ihbarname89_2))
            //   await this.setVarsayilanIhbarname89_2(borclu);
            // if (this.talepler.some(talep => talep.talepKodu == this.hacizEvrakTuru.ihbarname89_3))
            //   await this.setVarsayilanIhbarname89_3(borclu);
          }
          this.message = Number(index + 1) + ". dosyanın talepleri hazır."
        } catch (err) {
          task.status = this.taskDurum.BITTI_HATALI;
          this.message = Number(index + 1) + ". dosyanın talepleri hazırlanırken hata oluştu. (" + err + ")"
          task.description = err.message;
        } finally {
          this.input();
        }
      }
      this.durum = this.topluHacizDurum.hazir;
      this.genelIslemForm.nextStep();
      this.onFly = false;
    }
  }

  showTalep(talepKod: UyapHacizEvrakTuru): boolean {
    return !!this.talepler.find((talep: AvukatTalepListCevapRow) => (talep.talepKodu == talepKod));
  }

  bankaHacziBadgeContent(borclu: { isKurum(): boolean, bankaBilgileri: { sorguSonucu?: boolean, sorguSonucDVO?: unknown[] } }): string {
    if (borclu.isKurum()) {
      return "!";
    }
    return borclu.bankaBilgileri.sorguSonucu && (borclu.bankaBilgileri.sorguSonucDVO?.length || 0) > 0 ? "\u2713" : "-";
  }

  bankaHacziBadgeColor(borclu: { isKurum(): boolean, bankaBilgileri: { sorguSonucu?: boolean, sorguSonucDVO?: unknown[] } }): string {
    if (borclu.isKurum()) {
      return "orange darken-2";
    }
    return borclu.bankaBilgileri.sorguSonucu && (borclu.bankaBilgileri.sorguSonucDVO?.length || 0) > 0 ? "green" : "red";
  }

  addAllTasinirDosya(data: any, takip: any) {
    takip.task.response.borclular.forEach((borclu: any) => {
      borclu.haciz.tasinirHacizParams = (data);
    });
    this.input();
  }

  addAllTasinirDosyalar(data: any) {
    this.localValue.secilen_takipler.forEach(takip => {
      this.addAllTasinirDosya(data, takip);
    });
  }

  addAllBankaDosya(data: any, takip: any) {
    takip.task.response.borclular.forEach((borclu: any) => {
      if (!borclu.kurumAdi && data.haricAdi == 'BELEDIYE')
        delete data.haricAdi
      else if (borclu.kurumAdi && data.haricAdi == 'MAAS')
        delete data.haricAdi;
      borclu.haciz.bankaHesapHacziParams = data;
    });
    this.input();
  }

  addAllBankaDosyalar(data: any) {
    this.localValue.secilen_takipler.forEach(takip => {
      this.addAllBankaDosya(data, takip);
    })
  }



  async createTask() {
    this.onFly = true;
    let borcluSecildiMi = false;
    let tasks: Array<Task> = [];
    let takip: any;
    for (takip of this.localValue.secilen_takipler.filter(x=>x.task.status == this.taskDurum.BITTI_BASARILI)) {
      for (let borclu of takip.task.response.borclular) {
        let dosya = Object.assign({},takip.task.response.dosya);
        delete dosya.borclular;
        delete borclu.digerTalep;
        delete borclu.tebligat;
        if (borclu.selected) {
          if (borclu.egm?.sorguSonucDVO?.aracBilgileri?.aracList) {
            borclu.egm.sorguSonucDVO.aracBilgileri.aracList.forEach((arac: any) => delete arac.mahrumiyet);
          }
          borcluSecildiMi = true;
          let task: Task = new Task();
          task.dosya_esas_no = takip.dosyaNo;
          task.birim_adi = takip.birimAdi;
          task.birim_id = takip?.birimId;
          task.uyap_dosya_acilis_tarihi = takip.dosyaAcilisTarihi ? new Date(this.$uyapHelper.formatDate(takip.dosyaAcilisTarihi)).toString() : "";
          task.dosya_id = takip.dosyaId;
          task.task_type_id = TaskTuru.toplu_haciz_gonder;
          task.data = {
            dosya: dosya,
            params: takip.task.response.params,
            borclu: borclu
          };
          tasks.push(task);
        }
      }
    }
    if (borcluSecildiMi) {
      let res = await this.$store.dispatch('postTasks', tasks);
      if (this.$store.getters.getAutoPlay)
        await this.$router.push(ProgramPaths.eicrapro + '/haciz-gonder-detay/' + res.data.id);
      else
        await this.$router.push(ProgramPaths.eicrapro + '/islemler');
      this.genelIslemForm.activeStep++;
    } else
      this.$toast.warning('Talep gönderilecek borçlu seçiniz.')
    this.onFly = false;
  }
}

enum TopluHacizDurum {
  bosta = 1,
  hazirlaniyor = 2,
  hazir = 3
}
